import { IReferralConfig } from '@nkr/models/index'
import { IValidation } from './validation'
import { Col, ControlLabel, FormControl, FormGroup, Panel, Radio } from 'react-bootstrap'

interface IProps {
    data: IReferralConfig,
    validation: IValidation,
    dirty: boolean,
    onRadioChange: (e: React.FormEvent<Radio & HTMLInputElement>) => void,
    onDataChange: (e: React.FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => void
}

const LiverDonorsOnly = (props: IProps) => {
    return (
        <Panel>
            <Panel.Heading>Liver Donors Only</Panel.Heading>
            <Panel.Body>
                <FormGroup validationState={props.dirty && !props.validation.liverDonorMaxAge ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Max age for liver donor?</Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            type='text'
                            id='liverDonorMaxAge'
                            placeholder='0 to 255'
                            value={props.data.liverDonorMaxAge}
                            onChange={props.onDataChange}
                        />
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.bmiLimitLiver ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Max BMI for work-up?</Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            type='text'
                            id='bmiLimitLiver'
                            value={props.data.bmiLimitLiver}
                            onChange={props.onDataChange}
                        />
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.bmiRequiredForSurgeryLiver ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Max BMI for surgery?</Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            type='text'
                            id='bmiRequiredForSurgeryLiver'
                            value={props.data.bmiRequiredForSurgeryLiver}
                            onChange={props.onDataChange}
                        />
                    </Col>
                </FormGroup>

                {/* <FormGroup validationState={props.dirty && !props.validation.liverRuleOutKidneyDisease ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Rule out on kidney disease?</Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='liverRuleOutKidneyDisease' value={1} checked={props.data.liverRuleOutKidneyDisease != null ? props.data.liverRuleOutKidneyDisease : false} onChange={props.onRadioChange}>Yes</Radio>
                        <Radio inline name='liverRuleOutKidneyDisease' value={0} checked={props.data.liverRuleOutKidneyDisease != null ? !props.data.liverRuleOutKidneyDisease : false} onChange={props.onRadioChange}>No</Radio>
                    </Col>
                </FormGroup> */}

                <FormGroup validationState={props.dirty && !props.validation.liverRuleOutLiverDisease ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Rule out on liver disease?</Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='liverRuleOutLiverDisease' value={1} checked={props.data.liverRuleOutLiverDisease != null ? props.data.liverRuleOutLiverDisease : false} onChange={props.onRadioChange}>Yes</Radio>
                        <Radio inline name='liverRuleOutLiverDisease' value={0} checked={props.data.liverRuleOutLiverDisease != null ? !props.data.liverRuleOutLiverDisease : false} onChange={props.onRadioChange}>No</Radio>
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.liverRuleOutHepB ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Rule out on Hepatitis B?</Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='liverRuleOutHepB' value={1} checked={props.data.liverRuleOutHepB != null ? props.data.liverRuleOutHepB : false} onChange={props.onRadioChange}>Yes</Radio>
                        <Radio inline name='liverRuleOutHepB' value={0} checked={props.data.liverRuleOutHepB != null ? !props.data.liverRuleOutHepB : false} onChange={props.onRadioChange}>No</Radio>
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.liverRuleOutHepC ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Rule out on Hepatitis C?</Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='liverRuleOutHepC' value={1} checked={props.data.liverRuleOutHepC != null ? props.data.liverRuleOutHepC : false} onChange={props.onRadioChange}>Yes</Radio>
                        <Radio inline name='liverRuleOutHepC' value={0} checked={props.data.liverRuleOutHepC != null ? !props.data.liverRuleOutHepC : false} onChange={props.onRadioChange}>No</Radio>
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.liverRuleOutDiabetes ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Rule out on Diabetes?</Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='liverRuleOutDiabetes' value={1} checked={props.data.liverRuleOutDiabetes != null ? props.data.liverRuleOutDiabetes : false} onChange={props.onRadioChange}>Yes</Radio>
                        <Radio inline name='liverRuleOutDiabetes' value={0} checked={props.data.liverRuleOutDiabetes != null ? !props.data.liverRuleOutDiabetes : false} onChange={props.onRadioChange}>No</Radio>
                    </Col>
                </FormGroup>
            </Panel.Body>
        </Panel>
    )
}

export default LiverDonorsOnly;